import type {
  MyQuestionnaireRequestsListParams,
  MyTemplatesListParams,
  QuestionnairesListParams,
} from '../-types';

/** Serialises the `filter` query-string argument for `/v1/questionnaires`.
 *  The legacy backend reads a JSON-encoded string here rather than discrete
 *  params, hence the stringify. */
export function buildQuestionnairesFilterJson(
  params: QuestionnairesListParams,
): string {
  const filter: Record<string, unknown> = {
    isTemplate: 0,
    isArchived: params.isArchived ? 1 : 0,
  };
  if (params.name) filter.name = params.name;
  if (params.status && params.status.length > 0) {
    filter.status = params.status.join(',');
  }
  return JSON.stringify(filter);
}

/** Serialises the `filter` argument for `/api/questionnaires/requests`. */
export function buildMyRequestsFilterJson(
  params: MyQuestionnaireRequestsListParams,
): string {
  const filter: Record<string, unknown> = {};
  if (params.name) filter.name = params.name;
  if (params.about) filter.about = params.about;
  if (params.requestedByCompanyId) {
    filter.requestedByCompanyId = params.requestedByCompanyId;
  }
  return JSON.stringify(filter);
}

/** Serialises the `filter` argument for the template list. `isTemplate` /
 *  `isArchived` here are inert — neither has a backend filter-column mapping.
 *  The mode comes from the `myTemplates` query param in `useMyTemplatesQuery`. */
export function buildTemplatesFilterJson(
  params: MyTemplatesListParams,
): string {
  const filter: Record<string, unknown> = { isTemplate: 1, isArchived: 0 };
  if (params.name) filter.name = params.name;
  return JSON.stringify(filter);
}
